import * as React from 'react';

import SubscriptionTiersEnrollButton from 'bundles/coursera-plus/components/subscriptionTiers/SubscriptionTiersEnrollButton';
import type { PropsFromCaller as EnrollButtonProps } from 'bundles/coursera-plus/components/subscriptionTiers/SubscriptionTiersEnrollButton';
import withCourseraLiteCreateCartMutation from 'bundles/coursera-plus/utils/withCourseraLiteCreateCartMutation';
import type { PropsFromWithCourseraLiteCreateCartMutation } from 'bundles/coursera-plus/utils/withCourseraLiteCreateCartMutation';
import { submitEnrollmentPromise } from 'bundles/enroll-course/lib/enrollmentChoiceUtils';

type PropsFromCaller = Omit<EnrollButtonProps, 'onCtaClick'>;
type PropsToComponent = PropsFromCaller & PropsFromWithCourseraLiteCreateCartMutation;

export type CreateCourseraLiteCartType = PropsFromWithCourseraLiteCreateCartMutation['createCourseraLiteCart'];

export const handleCreateCourseraLiteCart = (createCourseraLiteCart: CreateCourseraLiteCartType) => {
  return submitEnrollmentPromise({ handleSubmitPromise: createCourseraLiteCart, options: {} });
};

const AllPlansCourseraLiteEnrollButton = ({ createCourseraLiteCart, ...props }: PropsToComponent) => {
  return (
    <SubscriptionTiersEnrollButton onCtaClick={() => handleCreateCourseraLiteCart(createCourseraLiteCart)} {...props} />
  );
};

export default withCourseraLiteCreateCartMutation<PropsFromCaller>(AllPlansCourseraLiteEnrollButton);
